import {
  AfterContentInit,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  HostBinding,
  Output,
  QueryList
} from '@angular/core';
import { CollectionItemComponent } from '../collection-item/collection-item.component';
import { Observable, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Easing } from '@tweenjs/tween.js';
import { PanEvent } from '../../touch/index';

@Component({
  selector: 'ui-collection',
  templateUrl: './collection.component.html'
})
export class CollectionComponent implements AfterContentInit, OnDestroy {
  @ContentChildren(CollectionItemComponent) items: QueryList<CollectionItemComponent>;
  /**
   * æå¨äºä»¶ $event ä¸ºå½åæå¨çè¿åº¦
   */
  @Output() uiSliding = new EventEmitter<number>();
  /**
   * å½å®ææ´å±åæ¢æ¶ï¼è§¦åäºä»¶ï¼ $event ä¸ºå½åæå¨çè¿åº¦
   */
  @Output() uiSlidingFinish = new EventEmitter<number>();
  /**
   * æ¯å¦ä¸ºåç´ç¿»é¡µï¼é»è®¤ä¸º falseï¼å³ä¸ºæ°´å¹³ç¿»é¡µ
   */
  @Input() vertical: boolean = false;
  /**
   * æ¯å¦å¡«æ»¡æ´ä¸ªå®¹å¨ï¼é»è®¤ä¸å¡«åï¼å¦è®¾ç½®ä¸º trueï¼é£ä¹ä¼å¡«åæ»¡ç¬¬ä¸ä¸ªæå®ä½çç¶çº§åç´ 
   */
  @Input()
  @HostBinding('class.ui-fill') fill: boolean = true;

  /**
   * æ¾ç¤ºç¬¬å å±çç´¢å¼
   */
  @Input()
  set index(value: number) {
    this._index = value;
    if (this.items) {
      cancelAnimationFrame(this.animationId);
      this.setStyle();
    }
  }

  get index() {
    return this._index;
  }

  // éè¿å­çº§çå¤å°ï¼è®¡ç®èªèº«ççå­å¤§å°
  get width() {
    return this.vertical ? 'auto' : this.childrenCount * 100 + '%';
  }

  get height() {
    return this.vertical ? this.childrenCount * 100 + '%' : 'auto';
  }

  transform: string = '';

  private get childrenCount() {
    if (this.items) {
      return this.items.length;
    }
    return 0;
  }

  private get stepDistance() {
    return this.vertical ? this.element.offsetHeight : this.element.offsetWidth;
  }

  private max: number = 0;

  private get min(): number {
    return -this.stepDistance * (this.childrenCount - 1);
  }

  // è®°å½å·²æå¨çè·ç¦»
  private distance: number = 0;
  private slidingEvent$: Observable<number>;
  private slidingEventSource = new Subject<number>();

  private subs: Array<Subscription> = [];
  private element: HTMLElement;
  private animationId: number;
  private _index: number = 0;

  private oldDistance = 0;

  constructor(private elementRef: ElementRef) {
    this.slidingEvent$ = this.slidingEventSource.asObservable();
  }

  ngAfterContentInit() {
    this.element = this.elementRef.nativeElement;
    this.subs.push(this.slidingEvent$.pipe(distinctUntilChanged()).subscribe((n: number) => {
      this.uiSliding.emit(n);
    }));
    this.setStyle();
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe());
  }

  drag(event: PanEvent) {
    if (event.first) {
      this.oldDistance = this.distance;
    }
    if ((this.vertical && event.firstDirection !== 'up' && event.firstDirection !== 'down') ||
      (!this.vertical && event.firstDirection !== 'left' && event.firstDirection !== 'right')) {
      event.stop();
      return;
    }
    if (event.type === 'touchmove') {
      let distance = this.oldDistance + (this.vertical ? event.distanceY : event.distanceX);
      if (distance > this.max) {
        distance /= 3;
      } else if (distance < this.min) {
        distance = this.min + (distance - this.min) / 3;
      }
      this.distance = distance;

      this.transform = `translate${this.vertical ? 'Y' : 'X'}(${distance}px)`;
      // åéäºä»¶ï¼å¹¶ä¼ åºå½åå·²æ»å¨å°ç¬¬å å±çè¿åº¦
      this.slidingEventSource.next(distance / this.stepDistance * -1);
      event.srcEvent.stopPropagation();
    } else if (event.type === 'touchend') {
      if (this.distance > this.max) {
        this.autoUpdateStyle(this.max);
        return;
      } else if (this.distance < this.min) {
        this.autoUpdateStyle(this.min);
        return;
      }
      let translateDistance: number;
      const targetIndex = Math.ceil(this.distance / this.stepDistance);
      const offset = Math.abs(this.distance % this.stepDistance);
      if (event.durationTime < 200 && Math.abs(this.vertical ? event.distanceY : event.distanceX) > 50) {
        // swipe
        if (this.oldDistance < this.distance) {
          translateDistance = targetIndex * this.stepDistance;
        } else {
          translateDistance = targetIndex * this.stepDistance - this.stepDistance;
        }
      } else {
        if (offset < (this.stepDistance / 2)) {
          translateDistance = targetIndex * this.stepDistance;
        } else {
          translateDistance = targetIndex * this.stepDistance - this.stepDistance;
        }
      }
      this.autoUpdateStyle(translateDistance);
    }
  }

  setStyle() {
    this.distance = this.index * -1 * this.stepDistance;
    this.transform = `translate${this.vertical ? 'Y' : 'X'}(${this.distance}px)`;
  }

  private autoUpdateStyle(translateDistance: number) {
    const max = 20;
    let step = 0;

    const distance = translateDistance - this.distance;

    if (distance === 0) {
      return;
    }

    const rawDistance = this.distance;

    const moveToTarget = () => {
      step++;
      const translate = rawDistance + Easing.Cubic.Out(step / max) * distance;
      this.distance = translate;
      this.transform = `translate${this.vertical ? 'Y' : 'X'}(${translate}px)`;

      this.slidingEventSource.next(translate / this.stepDistance * -1);
      if (step < max) {
        this.animationId = requestAnimationFrame(moveToTarget);
      } else {
        // åéäºä»¶ï¼å¹¶ä¼ åºå½åæ»å¨å°äºç¬¬å å±
        this.uiSlidingFinish.emit(this.distance / this.stepDistance * -1);
      }
    };

    this.animationId = requestAnimationFrame(moveToTarget);
  }
}
